var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSquareFootage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2727 23.6364L41.6332 19.275L31.218 8.85774L26.8575 13.2191L15.359 1.74619C13.1927 -0.420606 9.66539 -0.420606 7.49903 1.74619L2.22198 7.0243C0.055617 9.1911 0.055617 12.7191 2.22198 14.8859L13.6926 26.3588L0.5 39.5819V49.9992H10.9152L24.1356 36.7761L35.6062 48.2491C38.2448 50.8881 41.7998 49.9158 43.4663 48.2491L48.7433 42.9709C50.9097 40.8041 50.9097 37.2762 48.7433 35.1094L37.2727 23.6364ZM17.6643 22.4141L6.16588 10.9412L11.4152 5.6631L14.9424 9.1911L11.6651 12.4969L15.5812 16.4138L18.8863 13.108L22.9136 17.136L17.6643 22.4141ZM39.5501 44.3321L28.0795 32.8592L33.3565 27.5811L37.3838 31.6091L34.0787 34.9149L37.9948 38.8318L41.2999 35.526L44.8272 39.054L39.5501 44.3321Z",
    fill: "#1378A5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareFootage);
export default __webpack_public_path__ + "static/media/squareFootage.4c4ab5b08ef43a390a05ec6a8d08eb8a.svg";
export { ForwardRef as ReactComponent };